import type { ReactNode } from 'react';
import { Label } from 'shared/ui/label';
export default function FormControlWithLabel({
  text,
  children,
  htmlFor
}: {
  text: string;
  htmlFor?: string;
  children: ReactNode;
}) {
  return <div className="grid items-center gap-1" data-sentry-component="FormControlWithLabel" data-sentry-source-file="form-control-with-label.tsx">
      <Label className="text-title5" htmlFor={htmlFor} data-sentry-element="Label" data-sentry-source-file="form-control-with-label.tsx">
        {text}
      </Label>
      {children}
    </div>;
}